module.exports = __webpack_public_path__ + "img/hr-dry-tree-08.d2beff36.png";